import { gql } from '@apollo/client';

export default gql`
  query partnerLocationId($id: ID) {
    partnerLocation(id: $id) {
      id
      settingGroupOptionIds
    }
  }
`;
